export class FavouriteModel {
    FavoriteId?: bigint;
    UserId?: bigint;
    RequestId?: bigint;
}